import BaseModel from './Base.model';

export class PurchaseOrderDetailModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id || null,
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    });
    this.productId = data.productId || '';
    this.product = data.product || null;
    // Flat product fields — BE eager-load product qua leftJoin trong detail().
    // Expose tại model để view binding khỏi phải `d.product?.name` từng chỗ.
    this.productName = data.product?.name || data.productName || '';
    this.productCode = data.product?.code || data.productCode || '';
    // BE Product entity (XMĐ) không có barCode — bỏ hoàn toàn, dùng productCode.
    // ERP bán xe ưu tiên hiển thị mã SP + type (CHASSIS_ENGINE/SERIES) ở UI.
    this.productType = data.product?.type || data.productType || '';
    this.quantity = data.quantity || 0;
    this.quantityApprove = data.quantityApprove || 0;
    this.unitPrice = Number(data.unitPrice) || 0;
    this.beforeVatPrice = Number(data.beforeVatPrice) || 0;
    this.prevUnitPrice = Number(data.prevUnitPrice) || 0;
    this.discountAmount = Number(data.discountAmount) || 0;
    this.totalAmount = Number(data.totalAmount) || 0;
    this.vatAmount = Number(data.vatAmount) || 0;
    this.vatType = data.vatType || null;
    this.vatValue = Number(data.vatValue) || 0;
    this.salePowerWeek = data.salePowerWeek || 0;
    this.salePowerMonth = data.salePowerMonth || 0;
    this.salePrice = Number(data.salePrice) || 0;
    this.deleted = data.deleted || false;
  }
  static fromJson(d) {
    return BaseModel.fromJson(d, PurchaseOrderDetailModel);
  }
  static fromJsonArray(a) {
    return BaseModel.fromJsonArray(a, PurchaseOrderDetailModel);
  }
}

export class PurchaseOrderModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id || null,
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    });
    this.code = data.code || '';
    this.storeId = data.storeId || '';
    this.providerId = data.providerId || '';
    this.type = data.type ?? null;
    this.sourceType = data.sourceType ?? null;
    this.status = data.status ?? 1;
    this.relationType = data.relationType ?? 1;
    this.parentId = data.parentId ?? null;

    this.totalAmount = Number(data.totalAmount) || 0;
    this.totalGoods = Number(data.totalGoods) || 0;
    this.vatType = data.vatType || null;
    this.vatValue = Number(data.vatValue) || 0;
    this.vatAmount = Number(data.vatAmount) || 0;
    this.vatDate = data.vatDate || null;
    this.vatCode = data.vatCode || '';
    this.vatSerial = data.vatSerial || '';

    this.discountType = data.discountType || null;
    this.discountValue = Number(data.discountValue) || 0;
    this.discountAmount = Number(data.discountAmount) || 0;

    this.cashAmount = Number(data.cashAmount) || 0;
    this.cashAccountCode = data.cashAccountCode || '';
    this.cashAccountId = data.cashAccountId || null;
    this.transferAmount = Number(data.transferAmount) || 0;
    this.transferAccountCode = data.transferAccountCode || '';
    this.transferAccountId = data.transferAccountId || null;
    this.debtAmount = Number(data.debtAmount) || 0;
    this.payDate = data.payDate || null;
    // BE entity transformer trả boolean; nếu null thì default true.
    this.isVAT = data.isVAT == null ? true : Boolean(data.isVAT);

    this.requestBy = data.requestBy || null;
    this.requestDate = data.requestDate || null;
    this.inChargeEmployeeId = data.inChargeEmployeeId || null;
    this.description = data.description || '';
    this.importReason = data.importReason || '';

    // P2 audit fields — BE trả qua detail()/list() khi đã duyệt.
    this.purchaseApproveBy = data.purchaseApproveBy || null;
    this.purchaseApproveDate = data.purchaseApproveDate || null;
    this.accountantApproveBy = data.accountantApproveBy || null;
    this.accountantApproveDate = data.accountantApproveDate || null;
    this.cancelReason = data.cancelReason || '';

    this.store = data.store || null;
    this.provider = data.provider || null;
    this.createdByUser = data.createdByUser || null;
    // P6 — BE join 2 approver User relation; FE List.vue hiển thị fullName + tooltip.
    this.purchaseApprover = data.purchaseApprover || null;
    this.accountantApprover = data.accountantApprover || null;
    this.details = PurchaseOrderDetailModel.fromJsonArray(data.details || []);

    this.lineItemCount = data.lineItemCount ?? this.details.length;

    // Aggregate số lượng từ BE (drive nút "Tạo phiếu nhập").
    this.totalProductQuantity = Number(data.totalProductQuantity) || 0;
    this.totalImportQuantity = Number(data.totalImportQuantity) || 0;

    // Tree: Con của PO Cha (eager từ BE). Đệ quy nông — Con không có Con.
    this.children = (data.children || []).map(
      (c) => new PurchaseOrderModel(c),
    );
  }
  static fromJson(d) {
    return BaseModel.fromJson(d, PurchaseOrderModel);
  }
  static fromJsonArray(a) {
    return BaseModel.fromJsonArray(a, PurchaseOrderModel);
  }
}
